// Dependencies
import styled, { css } from 'styled-components'

// Utils
import { MediaQueries } from 'utils/breakpoints'

export const Container = styled.div`
  display: block;
  margin: 0 auto !important;
  width: 100%;
  height: calc(100dvh - 81px);
  max-width: 100%;
  padding: 16px;

  display: flex;
  flex-direction: column;
  justify-content: space-between;

  ${MediaQueries.notebook} {
    width: 1216px;
  }
`

export const UserButtonWrapper = styled.div`
  position: relative;
`


export const ButtonsWrapper = styled.div`
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 8px;
  padding: 0 8px;

  ${MediaQueries.medium} {
    width: 60%;
    margin: 0 auto;
  }
`

export const Button = styled.button<{ buttonColor: string }>`
  display: flex;
  align-items: center;
  justify-content: center;

  background-color: transparent;

  width: 100%;
  padding: 12px 0;
  border: 1px solid;
  border-radius: 4px;

  font-weight: bold;

  ${({ buttonColor }) => {
    if (buttonColor) {
      return css`
        color: ${buttonColor};
        border-color: #${buttonColor};

        &:hover {
          background-color: ${buttonColor};
          color: white;
        }
      `
    }
  }}
`

export const ButtonImage = styled.img`
  margin-right: 8px;
  max-width: 100%;
  max-height: 100%;
`
